import { useEffect, useContext } from 'react';
import { AllhomesGlobalContext } from './allhomes-global-context';
export var useAllhomesContext = function useAllhomesContext() {
  for (var _len = arguments.length, requestedValues = new Array(_len), _key = 0; _key < _len; _key++) {
    requestedValues[_key] = arguments[_key];
  }
  var context = useContext(AllhomesGlobalContext);
  useEffect(() => {
    var _context$setRequested;
    context === null || context === void 0 ? void 0 : (_context$setRequested = context.setRequestedValues) === null || _context$setRequested === void 0 ? void 0 : _context$setRequested.call(context, ...requestedValues);
  }, [requestedValues, context]);
  return context || {};
};